import { render, staticRenderFns } from "./menu-sales-inquiry.vue?vue&type=template&id=6f3d31a7&"
import script from "./menu-sales-inquiry.vue?vue&type=script&lang=js&"
export * from "./menu-sales-inquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports